import { useState } from "react";
import emailjs from "emailjs-com";

const initialState = {
	name: "",
	zalo: "",
	message: "",
};
export const Contact = (props) => {
	const [{ name, zalo, message }, setState] = useState(initialState);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setState((prevState) => ({ ...prevState, [name]: value }));
	};
	const clearState = () => setState({ ...initialState });

	const handleSubmit = (e) => {
		e.preventDefault();
		emailjs
			.sendForm(
				"service_gmail_teamaoxanh",
				"gmail_teamaoxanh",
				e.target,
				"WMGZjpGmQV_6efSLS"
			)
			.then(
				(result) => {
					console.log(result.text);
					clearState();
				},
				(error) => {
					console.log(error.text);
				}
			);
	};
	return (
		<div>
			<div id="contact">
				<div className="container">
					<div className="col-md-8">
						<div className="row">
							<div className="section-title">
								<h2>Liên lạc với chúng tôi</h2>
								<p>Hãy để lại thông tin chúng tôi sẽ liên hệ với bạn!</p>
							</div>
							<form name="sentMessage" validate onSubmit={handleSubmit}>
								<div className="row">
									<div className="col-md-6">
										<div className="form-group">
											<input
												type="text"
												id="name"
												name="name"
												className="form-control"
												placeholder="Bạn tên là gì?"
												required
												onChange={handleChange}
											/>
											<p className="help-block text-danger"></p>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<input
												type="text"
												id="zalo"
												name="zalo"
												className="form-control"
												placeholder="Zalo của bạn?"
												required
												onChange={handleChange}
											/>
											<p className="help-block text-danger"></p>
										</div>
									</div>
								</div>
								<div className="form-group">
									<textarea
										name="message"
										id="message"
										className="form-control"
										rows="4"
										placeholder="Bạn muốn nhắn gì cho chúng tôi không?"
										required
										onChange={handleChange}
									></textarea>
									<p className="help-block text-danger"></p>
								</div>
								<div id="success"></div>
								<button type="submit" className="btn btn-custom btn-lg">
									Gửi lời nhắn
								</button>
							</form>
						</div>
					</div>
					<div className="col-md-3 col-md-offset-1 contact-info">
						<div className="contact-item">
							<h3>Thông tin liên hệ</h3>
							<p>
								<span>
									<i className="fa fa-map-marker"></i> Địa chỉ
								</span>
								{props.data ? props.data.address : "loading"}
							</p>
						</div>
						<div className="contact-item">
							<p>
								<span>
									<i className="fa fa-phone"></i>Hotline
								</span>{" "}
								{props.data ? props.data.phone : "loading"}
							</p>
						</div>
						<div className="contact-item">
							<p>
								<span>
									<i className="fa fa-envelope-o"></i> E-mail
								</span>{" "}
								{props.data ? props.data.email : "loading"}
							</p>
						</div>
					</div>
					<div className="col-md-12">
						<div className="row">
							<div className="social">
								<ul>
									<li>
										<a href={props.data ? props.data.facebook : "/"}>
											<i className="fa fa-facebook"></i>
										</a>
									</li>
									<li>
										<a href={props.data ? props.data.youtube : "/"}>
											<i className="fa fa-youtube"></i>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="footer">
				<div className="container text-center">
					<p>
						&copy; 2022 Team Áo Xanh
						{/* <i class="fa fa-heart" aria-hidden="true"></i> */}
					</p>
				</div>
			</div>
		</div>
	);
};
